import {Injectable} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SecondLanguageService {



  private languages : string[] ;


  setLanguages(languages: string[]): void {
    this.languages = languages;
  }

  getLanguages(): string[] {
    return this.languages;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/second-language.service.ts